module.exports = __webpack_public_path__ + "static/media/portugueselanguageteacher.16cde35b.jpg";